const WidgetDailyAccountability = (app) => {
  app
    .post(
      "/widget-daily-accountability/save/:id?",
      async ({ api, assert, flash, req, res }) => {
        const { body, params } = req;

        assert(body.name, 400, "Template name is required");
        assert(
          Array.isArray(body.list),
          400,
          "Accountabilities list is required"
        );

        if (params.id && params.id !== "undefined") {
          await api(`widget-daily-accountability-template/${params.id}`, {
            method: "PUT",
            body,
          });
        } else {
          await api("widget-daily-accountability-template", {
            method: "POST",
            body,
          });
        }

        flash("success", "Successfully saved");

        res.backDontScroll();
      }
    )
    .get(
      "/widget-daily-accountability/delete/:id",
      async ({ api, flash, req, res }) => {
        const { id } = req.params;

        await api(`widget-daily-accountability-template/${id}`, {
          method: "DELETE",
        });

        flash("success", "Successfully removed");

        res.backDontScroll();
      }
    )
    .post(
      "/widget-daily-accountability/reorder",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        assert(
          body.orderedTemplates,
          400,
          "You need to provide an array with the order of the templates"
        );

        await api("widget-daily-accountability-template-reorder", {
          method: "PUT",
          body,
        });

        flash("success", "Successfully reordered");
        res.backDontScroll();
      }
    )
    .post(
      "/widget-daily-accountability/status/:id",
      async ({ api, assert, flash, req, res }) => {
        const {
          body: { status },
          params: { id },
        } = req;
        const verbs = {
          draft: "unpublish",
          published: "publish",
        };

        assert(status, 400, "Status is required");
        assert(id, 400, "Template ID is required");

        const verb = verbs[status];

        await api(`widget-daily-accountability-template/${id}`, {
          method: "PUT",
          body: { status },
        });

        flash("success", `Successfully ${verb}ed`);

        res.backDontScroll();
      }
    );
};

export default WidgetDailyAccountability;
